export default __webpack_public_path__ + "static/media/proteins.bd2f8704.png";